export const DUMMY_VALUE_TO_CLEAR_RADIO_GROUP = 'DUMMY_VALUE_TO_CLEAR_RADIO_GROUP';

const TAB_LIST_HEIGHT_PX = 48;
const FR_SEARCH_PAGES_HEADER_HEIGHT_PX = 56;
export const SEARCH_FORM_FOOTER_HEIGHT_PX = 96;
export const FR_SEARCH_FORM_FOOTER_HEIGHT_PX = 120;
export const SEARCH_RESULTS_FOOTER_HEIGHT_PX = 64;
export const SEARCH_RESULTS_EXPORTS_FOOTER_HEIGHT_PX = 56;

export const TOTAL_NON_FORM_HEIGHT_PX = TAB_LIST_HEIGHT_PX + SEARCH_FORM_FOOTER_HEIGHT_PX;
export const TOTAL_NON_RESULTS_HEIGHT_PX = TAB_LIST_HEIGHT_PX + SEARCH_RESULTS_FOOTER_HEIGHT_PX;
export const FR_TOTAL_NON_RESULTS_HEIGHT_PX =
    FR_SEARCH_PAGES_HEADER_HEIGHT_PX + SEARCH_RESULTS_FOOTER_HEIGHT_PX;
export const TOTAL_NON_SAVED_SEARCHES_HEIGHT_PX = TAB_LIST_HEIGHT_PX;

export const DEFAULT_RESULTS_PER_PAGE = 25;

export const MAX_TOTAL_RESULT_COUNT = 25000;

export const INPUT_WIDTH_SM = '10rem';
export const INPUT_PERCENTAGE_WIDTH_SM = '18%';
export const INPUT_WIDTH_MD = '354px';
export const INPUT_PERCENTAGE_WIDTH_MD = '48%';
export const UNIT_SEARCH_FORM_INPUT_WIDTH = '251px';
export const UNIT_SEARCH_FORM_INPUT_PERCENTAGE_WIDTH = '24%';
export const UNIT_TIME_RANGE_FIELDS_HEIGHT = '57px';
export const UNIT_SEARCH_INVOLVED_LOCATION_COMMON_WIDTH = '500px';
export const UNIT_SEARCH_STATUSES_COMMON_WIDTH = '400px';

export const SEARCH_FORM_WIDTH = '720px';
export const SEARCH_FORM_EXTENDED_WIDTH = '902px';

export const DEFAULT_MAX_GROUPS = 100;
